/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import Card from 'components/Card';
import Metadata from 'images/Metadata.svg';
import styles from './FiltersCard.scss';

export default function FilterCardMetadata({
  title,
  link,
  metaKey,
  metaValue,
  metadatas,
  onClick,
  ...props
}) {
  const hasMetaKeyOrValue = (metaKey && metaKey.length > 0) || (metaValue && metaValue.length > 0);
  const hasMetadatas = (metadatas && metadatas.length > 0);

  let numberOfMetadatasFiltered = hasMetaKeyOrValue ? 1 : 0;

  if (hasMetadatas) {
    numberOfMetadatasFiltered += metadatas.length;
  }

  const cardDescription = `${numberOfMetadatasFiltered} Metadata filtered`;
  const leftActionText = hasMetaKeyOrValue || hasMetadatas ? 'Edit' : 'Add';
  return (
    <Card
      title={title}
      value={<Metadata name={title} className={styles.icon} />}
      description={cardDescription}
      leftActionText={leftActionText}
      leftAction={() => onClick(link)}
      {...props}
    />
  );
}
